import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { QueryParams } from '@/core/query-params.service';
import SearchField from './SearchField.vue';
import ScrollService from '@/core/scroll.service';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { computed, onMounted, ref, watch } from 'vue';
import { watchRelativeUrl } from '@/core/route.service';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResult',
  setup(__props) {

const showAuthTopBar = computed<boolean>(() => store.getters['app/showAuthTopBar']);
const showEmptyTopBar = computed<boolean>(() => store.getters['app/showEmptyTopBar']);
const usp = computed<IUsp>(() => store.getters['app/usp']);

const isSearching = computed<boolean>(() => store.getters['search/isSearching']);
const hasSearched = computed<boolean>(() => store.getters['search/hasSearched']);
const searchResult = computed<SearchResultsViewModel>(() => store.getters['search/searchResult']);

function search(term: string) : Promise<any> {
    return store.dispatch('search/search', term);
}

const isMegaMenuOpen = computed<boolean>(() => store.getters['navigation/isMegaMenuOpen']);

const searchTerm = ref<string>('');
const isSearchOpen = ref<boolean>(false);

const backgroundContainerHeight = ref<string>('');
const overlayContainerTop = ref<string>('');

const searchField = ref(null);

watchRelativeUrl(onRouteChange);
function onRouteChange(route: RelativeUrl, oldRoute: RelativeUrl) {
    if (route && oldRoute && route.path === oldRoute.path) {
        searchProducts(true);
    }
}

onMounted(searchProducts);

watch(isMegaMenuOpen, onIsMegaMenuOpenChanged);
function onIsMegaMenuOpenChanged(newVal): void {
    if (newVal) {
        searchField.value.closePopout();
    }
}

const router = useRouter();

function searchProducts(scrollToTop = false) {
    searchTerm.value = router.currentRoute.query[QueryParams.SearchTerm] as string;
    if (searchTerm.value) {
        search(searchTerm.value).then(() => {
            if (searchResult.value.exactMatchProductUrl) {
                router.push(searchResult.value.exactMatchProductUrl);
            }
            scrollToTop && setTimeout(ScrollService.scrollSearchResultIntoView, 100);
        });
    }
}

function toggleSearchPageSearch(active: boolean, resultsY: number, resultsHeight: number) {
    isSearchOpen.value = active;
    setContainerStyles(active, resultsHeight, resultsY);
}

async function setContainerStyles(active: boolean, height: number, y: number): Promise<void> {
    if (active) {
        return new Promise(resolve => {
            backgroundContainerHeight.value = (height + y) + 'px';
            overlayContainerTop.value = y + 'px';
            return resolve();
        });
    }
    return new Promise(resolve => {
        backgroundContainerHeight.value = '';
        setTimeout(() => {
            if (!isSearchOpen.value) {
                overlayContainerTop.value = '';
            }
        }, 1400);
        return resolve();
    });
}

const breakpointIsActive = useBreakpoints();

const isLargeBreakpoint = computed<boolean>(() => {
    return breakpointIsActive.value.large;
});

const searchBackgroundContainerStyle = computed<any>(() => {
    return {
        height: isLargeBreakpoint.value && backgroundContainerHeight.value
            ? backgroundContainerHeight.value
            : ''
    };
});
const searchOverlayContainerStyle = computed<any>(() => {
    return { top: isLargeBreakpoint.value && overlayContainerTop.value ? overlayContainerTop.value : '' };
});

const shouldShowNoResultsText = computed<boolean>(() => {
    return hasSearched.value && !hasSearchResults.value;
});

const hasSearchResults = computed<boolean>(() => {
    const result = searchResult.value;
    if (!result) {
        return false;
    }

    const hasContent = result.groups && result.groups.contentGroup.items.length > 0;
    if (hasContent) { return true; }

    for (let i = 0; i < result.groups.productGroups.length; i++) {
        const hasProducts = result.groups.productGroups[i].items.length > 0;
        if (hasProducts) { return true; }
    }

    return false;
});

return { __sfc: true,showAuthTopBar, showEmptyTopBar, usp, isSearching, hasSearched, searchResult, search, isMegaMenuOpen, searchTerm, isSearchOpen, backgroundContainerHeight, overlayContainerTop, searchField, onRouteChange, onIsMegaMenuOpenChanged, router, searchProducts, toggleSearchPageSearch, setContainerStyles, breakpointIsActive, isLargeBreakpoint, searchBackgroundContainerStyle, searchOverlayContainerStyle, shouldShowNoResultsText, hasSearchResults, SearchField }
}

})